export const ACTION_ADD_CAMPAIGNS = 'ACTION_ADD_CAMPAIGNS';

export const ACTION_LOAD_CAMPAIGN_NAMES__REQUEST = 'ACTION_LOAD_CAMPAIGN_NAMES__REQUEST';
export const ACTION_LOAD_CAMPAIGN_NAMES__SUCCESS = 'ACTION_LOAD_CAMPAIGN_NAMES__SUCCESS';
export const ACTION_LOAD_CAMPAIGN_NAMES__FAIL = 'ACTION_LOAD_CAMPAIGN_NAMES__FAIL';

export const ACTION_CREATE_CAMPAIGN__REQUEST = 'ACTION_CREATE_CAMPAIGN__REQUEST';
export const ACTION_CREATE_CAMPAIGN__SUCCESS = 'ACTION_CREATE_CAMPAIGN__SUCCESS';
export const ACTION_CREATE_CAMPAIGN__FAIL = 'ACTION_CREATE_CAMPAIGN__FAIL';

export const ACTION_EDIT_CAMPAIGN__REQUEST = 'ACTION_EDIT_CAMPAIGN__REQUEST';
export const ACTION_EDIT_CAMPAIGN__SUCCESS = 'ACTION_EDIT_CAMPAIGN__SUCCESS';
export const ACTION_EDIT_CAMPAIGN__FAIL = 'ACTION_EDIT_CAMPAIGN__FAIL';

export const ACTION_SWITCH_CAMPAIGN_STATUS__REQUEST = 'ACTION_SWITCH_CAMPAIGN_STATUS__REQUEST';
export const ACTION_SWITCH_CAMPAIGN_STATUS__SUCCESS = 'ACTION_SWITCH_CAMPAIGN_STATUS__SUCCESS';
export const ACTION_SWITCH_CAMPAIGN_STATUS__FAIL = 'ACTION_SWITCH_CAMPAIGN_STATUS__FAIL';
